import { Flex, Text } from '@nula/core-ui';
import styles from './empty-canvas.module.css';

export function EmptyCanvas() {
  // Per client.md §16: subtle centered hint with tool-shortcut priming.
  // (Space-view variant copy is deferred until view-mode state lands; today we render the default.)
  return (
    <div className={styles.overlay}>
      <Flex vertical gap="sm" className={styles.hint}>
        <Text size="md" type="secondary">
          Click to add a sticky &nbsp;&bull;&nbsp; Press <kbd>/</kbd> for tools
        </Text>
      </Flex>
    </div>
  );
}
